export default "__VITE_ASSET__D6Z7EUdf__"